<template>
  <tbody>
    <tr>
      <td :colspan="cols" class="text-center table-loading">
        <span v-if="text">
          {{ text }}...
        </span>

        <span v-else>
          Laddar...
        </span>
      </td>
    </tr>
  </tbody>
</template>

<script>
  export default {
    name: "TableLoader",
    props: ['cols', 'text']
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/TableLoader.vue